import {
    ActionDynamicsEnum,
    FormattedPeriodsType,
    OnlinePresenceActionDynamicsType,
} from '../../../../../../service/online-presence/online-presence-type';
import {getEnumValue} from '../../../../../../util/enum';
import {CompareTable} from '../../../compare-table/compare-table';
import {SinglePeriodStatsTable} from '../../../single-period-stats/single-period-stats-table';
import {sortActionDynamicsValues, targetActionsTableLangKeyMap} from '../../target-actions-dynamics-helper';

type PropsType = {
    allowedKeys: Array<ActionDynamicsEnum>;
    data: OnlinePresenceActionDynamicsType;
    isCompareMode: boolean;
    formattedPeriods?: FormattedPeriodsType;
};

export function TargetActionsTable(props: PropsType): JSX.Element {
    const {data, isCompareMode, formattedPeriods, allowedKeys} = props;

    const filteredTableData = data.table
        .flatMap((dataItem) => {
            const dataItemKey = getEnumValue(ActionDynamicsEnum, dataItem.label);

            if (!dataItemKey || !allowedKeys.includes(dataItemKey)) {
                return [];
            }

            return [
                {
                    ...dataItem,
                    label: dataItemKey,
                },
            ];
        })
        .sort(sortActionDynamicsValues);

    return isCompareMode ? (
        <CompareTable
            formattedPeriods={formattedPeriods}
            metricsNameHeadKey="ONLINE_PRESENCE_ANALYTICS__PRIMARY_MARKERS__ACTION"
            rows={filteredTableData.map((dataItem) => {
                return {
                    titleKey: targetActionsTableLangKeyMap[dataItem.label],
                    currentValue: dataItem.current,
                    comparePeriodValue: dataItem.compared,
                    delta: dataItem.delta,
                };
            })}
        />
    ) : (
        <SinglePeriodStatsTable
            metricsNameHeadKey="ONLINE_PRESENCE_ANALYTICS__PRIMARY_MARKERS__ACTION"
            rows={filteredTableData.map((dataItem) => {
                return {
                    titleKey: targetActionsTableLangKeyMap[dataItem.label],
                    value: dataItem.current,
                };
            })}
        />
    );
}
